export default {
    "EXPLORE": "EXPLORE",
    "SHOP NOW": "SHOP NOW",
    "BOOK NOW": "BOOK NOW",
    "VIEW MORE": "VIEW MORE",
    "ORDER ON WHATSAPP": "ORDER ON WHATSAPP",
    "Phone": "Phone",
    "WhatsApp": "WhatsApp",
    "Instagram": "Instagram",
    "Snapchat": "Snapchat",
    "Twitter": "Twitter",
    "Youtube": "Youtube",
    "CHECKOUT OUR INSTAGRAM": "CHECK OUT OUR INSTAGRAM",
    "Powered by": "Powered by",
    "Get yours now!": " Get yours now!",
    "This site is Powered by Optimize App": "This site is Powered by Optimize App. ",
    "بو نبيل": "بو نبيل",
    "SHOP ON INSTAGRAM": "SHOP ON INSTAGRAM",
    "ORDER ON INSTAGRAM": "ORDER ON INSTAGRAM",
    "FOR INQUIRIES & ORDERS": "FOR ORDERS & INQUIRIES",
    "FOR RESERVATIONS & ORDERS": "FOR RESERVATION & INQUIRY",
    "CHECK OUT ON YOUTUBE": "CHECK OUT ON YOUTUBE",
    "CHECK OUT ON INSTAGRAM": "CHECK OUT ON INSTAGRAM",
    "CHECK OUT ON SNAPCHAT": "CHECK OUT ON SNAPCHAT"
}


// WEBPACK FOOTER //
// ./src/store/data/englishStrings.js